<template>
    <slick
        ref="slick"
        :options="slickOptions"
        :class="'slider--' + type"
        @init="handleInit"
        @afterChange="handleAfterChange"
    >
        <template v-if="type == 'homepage'">
            <a v-for="(slide, index) in src" :href="slide.link" target="_blank">
                <img
                    class="slider-img"
                    :key="index"
                    :src="slide.src"
                    style="width: 100%"
                />
            </a>
        </template>
        <template v-else-if="type == 'submenu'">
            <img v-for="(slide, index) in src" :key="index" :src="slide" />
        </template>
        <template v-else-if="type == 'banner'">
            <a
                v-for="(slide, index) in src"
                :key="index"
                :href="getBannerUrl(slide)"
                :target="slide.url ? '_blank' : ''"
            >
                <img class="slider-img" :src="slide.image" />
            </a>
        </template>
        <template v-else-if="type == 'news'">
            <div v-for="(group, index) in src" :key="index" class="news__list">
                <router-link
                    v-for="item in group"
                    :key="item.id"
                    class="news__item"
                    :to="item.url"
                >
                    <span class="news__title">{{
                        item.contents[0].title
                    }}</span>
                    <span class="news__date">{{ item.publishDate }}</span>
                </router-link>
            </div>
        </template>
    </slick>
</template>

<script>
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default {
    components: { Slick },

    props: ["type", "src"],

    computed: {
        slickOptions() {
            let options = {};
            if (this.type == "homepage" || this.type == "submenu") {
                options = {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    autoplay: true,
                    autoplaySpeed: 3000,
                };
            } else if (this.type == "banner") {
                options = {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false,
                    infinite: true,
                    speed: 500,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    fade: true,
                    cssEase: "linear",
                };
            } else if (this.type == "news") {
                options = {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false,
                    infinite: true,
                    speed: 500,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    fade: true,
                    cssEase: "linear",
                };
            }
            return options;
        },
    },

    methods: {
        next() {
            this.$refs.slick.next();
        },

        prev() {
            this.$refs.slick.prev();
        },

        handleInit(event, slick) {
            if (this.type == "banner") {
                this.$emit("slideChange", {
                    slideNumber: 0,
                    slideCount: slick.slideCount,
                });
            }
        },

        handleAfterChange(event, slick, currentSlide) {
            this.$emit("slideChange", {
                slideNumber: currentSlide,
                slideCount: slick.slideCount,
            });
        },
        getBannerUrl(slide) {
            if (slide.url)
                return slide.url + "?token=" + localStorage.getItem("token");
            return "javascript:void(0)";
        },
    },
};
</script>
